import { render, staticRenderFns } from "./SyncExternalFoodcardsButton.vue?vue&type=template&id=e44b1ba4"
import script from "./SyncExternalFoodcardsButton.vue?vue&type=script&lang=ts"
export * from "./SyncExternalFoodcardsButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports